/* seibertron-ja-cart-localization-20260806 */
(function () {
  'use strict';
  if (!/^ja(?:-|$)/i.test(document.documentElement.lang || '')) return;
  var exactMap = {"20% automatic discount applied in cart and checkout.":"カートとチェックアウトで20％の自動割引が適用されます。","Featured collection":"おすすめ商品","Color":"カラー","Color:":"カラー：","Style":"スタイル","Style:":"スタイル：","Size":"サイズ","Size:":"サイズ：","Black":"ブラック","White":"ホワイト","Red":"レッド","Blue":"ブルー","Green":"グリーン","Yellow":"イエロー","Orange":"オレンジ","Gray":"グレー","Grey":"グレー","Khaki":"カーキ","Brown":"ブラウン","Tan":"タン","Pink":"ピンク","Purple":"パープル","Navy":"ネイビー","Olive Green":"オリーブグリーン","Army Green":"アーミーグリーン","Fluorescent Yellow":"蛍光イエロー","X-Small":"XS","Extra Small":"XS","Small":"S","Medium":"M","Large":"L","X-Large":"XL","Extra Large":"XL","XX-Large":"XXL","2X-Large":"XXL","XXX-Large":"XXXL","3X-Large":"XXXL","Fit 17.3\" Laptop Black":"17.3インチPC対応・ブラック","Fit 17.3\" Laptop Khaki":"17.3インチPC対応・カーキ","Fit 14.1\" Laptop Black":"14.1インチPC対応・ブラック","Fit 14.1\" Laptop Khaki":"14.1インチPC対応・カーキ","1 piece of luggage strap black":"ラゲッジストラップ1個・ブラック","1 piece of luggage strap khaki":"ラゲッジストラップ1個・カーキ","No reviews yet":"レビューはまだありません"};
  var attributeMap = {"Cart":"カート","Close cart":"カートを閉じる","Remove":"削除","Decrease quantity":"数量を減らす","Increase quantity":"数量を増やす"};
  var blocked = { SCRIPT: true, STYLE: true, NOSCRIPT: true, TEXTAREA: true };
  var cartSelectors = [
    'main-cart-items', '#main-cart-items', '#main-cart-footer',
    'cart-drawer', '.cart-drawer', '[data-cart-drawer]',
    'cart-notification', '.cart-notification', '[data-cart-notification]'
  ];
  function clean(value) { return (value || '').replace(/\s+/g, ' ').trim(); }
  function variantValue(value) {
    if (exactMap[value]) return exactMap[value];
    if (value.indexOf(' / ') !== -1) {
      var parts = value.split(' / ');
      var translated = parts.map(function (part) { return exactMap[clean(part)] || clean(part); });
      if (translated.join(' / ') !== value) return translated.join(' / ');
    }
    return '';
  }
  function translateText(value) {
    var cleaned = clean(value);
    if (!cleaned) return '';
    if (exactMap[cleaned]) return exactMap[cleaned];
    var reviews = cleaned.match(/^(\d+)\s+reviews?$/i);
    if (reviews) return reviews[1] + '件のレビュー';
    var option = cleaned.match(/^(Color|Style|Size):\s*(.+)$/i);
    if (option) {
      var label = exactMap[option[1] + ':'];
      var translatedValue = variantValue(option[2]) || option[2];
      return label + translatedValue;
    }
    return '';
  }
  function roots() {
    var result = [];
    if (/^\/ja\/cart(?:\/|$)/.test(window.location.pathname || '')) {
      var main = document.querySelector('main');
      if (main) result.push(main);
    }
    cartSelectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (node) {
        if (result.indexOf(node) === -1 && !result.some(function (root) { return root.contains(node); })) result.push(node);
      });
    });
    return result;
  }
  function localize(scope) {
    var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (node) {
      if (!node.parentElement || blocked[node.parentElement.tagName]) return;
      var translated = translateText(node.nodeValue);
      if (!translated) return;
      var leading = (node.nodeValue.match(/^\s*/) || [''])[0];
      var trailing = (node.nodeValue.match(/\s*$/) || [''])[0];
      node.nodeValue = leading + translated + trailing;
    });
    scope.querySelectorAll('[aria-label],[title]').forEach(function (element) {
      ['aria-label', 'title'].forEach(function (name) {
        var value = clean(element.getAttribute(name));
        var translated = attributeMap[value] || translateText(value);
        if (translated) element.setAttribute(name, translated);
      });
    });
  }
  function inCartScope(node) {
    var element = node && (node.nodeType === 1 ? node : node.parentElement);
    if (!element) return false;
    if (/^\/ja\/cart(?:\/|$)/.test(window.location.pathname || '') && element.closest('main')) return true;
    return cartSelectors.some(function (selector) { return element.matches(selector) || element.closest(selector); });
  }
  roots().forEach(localize);
  new MutationObserver(function (mutations) {
    var pending = [];
    mutations.forEach(function (mutation) {
      if (mutation.type === 'characterData') {
        if (inCartScope(mutation.target)) pending.push(mutation.target.parentElement);
        return;
      }
      mutation.addedNodes.forEach(function (node) {
        var element = node.nodeType === 1 ? node : node.parentElement;
        if (element && inCartScope(element)) pending.push(element);
      });
    });
    pending.filter(function (node, index) { return node && pending.indexOf(node) === index; }).forEach(localize);
  }).observe(document.body, { childList: true, subtree: true, characterData: true });
})();
